import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiService, UserService, JwtService } from '@app/core';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.css']
})

export class PreferencesComponent implements OnInit {
  preferenceForm: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private apiService: ApiService,
    private userService: UserService,
    private jwtService: JwtService) { this.createForm(); }

  is_Editable: boolean = false;
  is_Paperless: boolean = false;
  is_CurrentEmail: boolean = true;
  //currentParticipantID: String;
  ParticipantID: string;
  optInInd: string;
  Email: string;
  message: string;
  save_Enabled = false;
  emailmessage: string;
  participantEmail: string;
  isAgree: boolean = false;
  isError: boolean = false;
  submitted = false;
  asterik: string;
  msgColor: string;
  preferencesMessage: string = '';
  ngOnInit() {
    this.getPreferenceData();
  }
  Edit() {
    this.is_Editable = true;
    /* const data = {};
    this.apiService.post("/login", data).subscribe(
      data => {
        this.Email = data.data.wctptUserVO.emailAddress;
        this.is_CurrentEmail = this.emailmessage == this.Email ? true : false;
        if (!this.is_CurrentEmail) {
          this.preferenceForm.controls['email'].setValue(this.emailmessage);
        } else {
          this.preferenceForm.controls['email'].setValue('');
        }
      }); */
      var loggedInUser = this.jwtService.getLoggedInUser();
      this.Email = loggedInUser.email;
      this.is_CurrentEmail = this.emailmessage == this.Email ? true : false;
      if (!this.is_CurrentEmail) {
        this.preferenceForm.controls['email'].setValue(this.emailmessage);
      } else {
        this.preferenceForm.controls['email'].setValue('');
      }
  }
  cancel() {
    this.is_Editable = false;
    this.isAgree = false;
    this.save_Enabled = false;
    this.preferenceForm.patchValue({
      email: null
    });
    this.getPreferenceData();
  }
  getPreferenceData() {
    // const params = { "participantId": this.currentParticipantID };
    return this.apiService.get("/profile").subscribe(
      data => {
        //participantEmail for initial page to display emailAddress
        this.participantEmail = data.data.participantVO.emailAddress;
        this.is_CurrentEmail = this.emailmessage == this.Email ? true : false;
        this.optInInd = data.data.participantVO.optInInd;
        this.emailmessage = this.participantEmail;
        if (this.optInInd == 'Y') {
          this.is_Paperless = true;
          this.message = "Electronic Delivery";
        } else if (this.optInInd == 'N') {
          this.is_Paperless = false;
          this.message = "Mail (paper format)"
          this.save_Enabled = true;
        }
      }
    );
  }
  save() {
    // stop here if form is invalid
    this.submitted = true;
    if (this.preferenceForm.invalid && !this.is_CurrentEmail) {
      this.isError = true;
      return;
    }
    var UpdateData = {
      //participantId: this.currentParticipantID.toString(),
      participantId: JSON.parse(localStorage.getItem('credentials')).participantId,
      email: this.is_CurrentEmail ? this.Email : this.preferenceForm.value.email,
      optIn: this.is_Paperless ? 'Y' : 'N'
    }
    this.userService.updatePreference(UpdateData).subscribe(
      res => {
        if (res.code == '200') {
          this.preferenceForm.controls['Agree'].setValue(false);
          this.optInInd = UpdateData.optIn;
          this.message = this.optInInd == 'Y' ? "Electronic Delivery (paperless)" : "Mail (paper format)";
          this.emailmessage = UpdateData.email;
          this.preferencesMessage = res.message;
          this.asterik = '*';
          this.msgColor = 'green';
          setTimeout(function () {
            this.preferencesMessage = null;
            this.asterik = null;
          }.bind(this), 5000);
          this.is_Editable = false;
          this.save_Enabled = false;
        }
      },
      err => {
        this.preferencesMessage = err.errors.message;
        this.asterik = '*';
        this.msgColor = 'red';
      }
    );
    return false;
  }
  getStatusColor() {
    return this.msgColor;
  }
  checkAgree() {
    var formData = this.preferenceForm.value;
    if (formData.Agree) {
      this.save_Enabled = true;
    }
    else {
      this.save_Enabled = false;
    }
  }
  regEmail() {
    this.preferenceForm.controls['email'].setValue('');
    this.is_CurrentEmail = true;
    this.isError = false;
  }
  altEmail() {
    this.is_CurrentEmail = false;
  }
  checkPaperless() {
    this.is_Paperless = true;
    this.save_Enabled = false;
  }
  checkPaper() {
    this.is_Paperless = false;
    this.save_Enabled = true;
  }
  private createForm() {
    this.preferenceForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.pattern('^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$'), Validators.maxLength(80)]),
      Agree: ['', Validators.required]
    });
  }
}
